import React, { useState } from "react";
import translations from "../translation.json";
import { useLanguage } from "../languageContext";
import { toast } from "react-toastify";
import { ApiUrl } from "../ApiUrl";

const AddRepresent = ({
  isDarkMode,
  setRepOptions,
  repOptions,
  editModal,
  setFieldValue,
  dealership_id
}) => {
  const { language } = useLanguage();
  var button = document.getElementById("closeAddRepresent");
  const [name, setName] = useState();
  const [error, setError] = useState("");
  const token = localStorage.getItem("token");
  const [loading , setLoading] = useState(false)
  // const handleSubmit = async (values) => {
  //   if (name) {
  //     const newOption = {
  //       label: name,
  //       value: name,
  //     };

  //     if (!repOptions.some((option) => option.value === newOption.value)) {
  //       setRepOptions([...repOptions, newOption]);
  //       setFieldValue("appointment_rep_user_name", newOption.value);
  //       setName("");
  //       toast.success(translations.alertMessages.repNameAddedSuccess[language]);
  //       button.click();
  //     }
  //   } else {
  //     setError();
  //   }
  // };
const handleSubmit = async () => {
  if (!name) {
    setError("Please enter a rep name.");
    return;
  }

  const payload = { name , dealership_id}; 
setError("");
  setLoading(true)
  try {
    const url = `${ApiUrl}/api/user/save-rep`;

    const res = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    const data = await res.json();
    console.log("aklsjklajdf",data)
    if (data.status === "success") {
      toast.success(data.message);
    
      const repName = data.appointmentRep.name;

      // Check if exists
      const exists = repOptions.some((o) => o.value === repName);

      // Add only if not exist
      if (!exists) {
        setRepOptions((prev) => [
          ...prev,
          { label: repName, value: repName },
        ]);
      }

      // Always select it
      setFieldValue("appointment_rep_user_name", repName);

      setName("");

      // Close modal AFTER success
      document.getElementById("closeAddRepresent")?.click();
    } else {
      toast.error(data.message);
    }
  } catch (err) {
    console.error(err);
    toast.error("Something went wrong!");
  }finally{
    setLoading(false)
  }
};



  return (
    <div id="AddRepresent" className="modal fade" tabindex="-1">
      <div
        className="modal-dialog modal-dialog-centered modal-lg"
        style={{ maxWidth: "500px" }}
      >
        <div className="modal-content">
          <div
            className="modal-header d-flex flex-column align-items-stretch"
            style={{
              borderBottom: isDarkMode
                ? "1px solid #495057"
                : "1px solid #dee2e6",
            }}
          >
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              id="closeAddRepresent"
              onClick={() => {
                if (editModal) {
                  document
                    .querySelectorAll(".modal-backdrop")
                    .forEach((backdrop) => {
                      backdrop.remove();
                    });
                  var createModal = new window.bootstrap.Modal(
                    document.getElementById("editAppointmentModal")
                  );
                  createModal.show();
                }
              }}
              style={{
                filter: isDarkMode ? "invert(1)" : "none",
                color: isDarkMode ? "#ffffff" : "rgb(255, 255, 255) !important",
              }}
            ></button>
          </div>
          <div class="modal-body p-4">
            <div className="mb-3 d-flex align-items-center gap-3">
              <input
                placeholder={translations.commonWords.repName[language]}
                onChange={(e) => setName(e.target.value)}
                value={name}
                className={`form-control ${
                  isDarkMode ? "custom-placeholder" : "light-placeholder"
                }`}
                // className={`form-control ${isDarkMode ? "custom-date" : ""}`}
                style={{
                  backgroundColor: isDarkMode ? "transparent" : "",
                  color: isDarkMode ? "#ffffff" : "#000000",
                  border: isDarkMode
                    ? "1px solid #495057"
                    : "1px solid #dee2e6",
                }}
              />

              {/* <button
                style={{ width: "100px" }}
                type="button"
                class="btn admin-btn btn-primary"
                data-bs-dismiss="modal"
                onClick={() => {
                  handleSubmit();
                }}
              >
                Add
              </button> */}
              <button
                style={{ width: "100px" }}
                type="button"
                className="btn admin-btn btn-primary"
                onClick={() => handleSubmit()}
                disabled={loading}
              >
                {loading ? "Saving..." : "Add"}
              </button>
            </div>
          </div>
          <div
            style={{
              height: "71px",
              borderTop: isDarkMode ? "1px solid #495057" : "1px solid #dee2e6",
            }}
            class="modal-footer"
            id="modalfooter"
          >
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
              onClick={() => {
                if (editModal) {
                  var createModal = new window.bootstrap.Modal(
                    document.getElementById("editAppointmentModal")
                  );
                  createModal.show();
                }
              }}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddRepresent;
